<app-header></app-header>
<app-sidebar
  ativo="CRM">
</app-sidebar>
<div class="content-wrapper">
  <section class="content">
    <div class="row">
      <div class="col-md-6">
        <app-breadcrumb
          Titulo="CRM - Detalhes"
          [TemPaginaPai] = "true"
          PaginaPai = "CRM"
          Pagina="Detalhes#{{atendimento.id}}"
          [LinkPaginaPai]="'cadastro/atendimento'"
        ></app-breadcrumb>
      </div>
      <div class="col-md-12 card">
        <div class="agendamento-header">
          <h6>
            Informações do lead <span class="titulo-id">#{{ atendimento.id }}</span>
          </h6>
        </div>
        <div class="texto-descricao-agendamento">
          {{ atendimento.descricao }}
        </div>

        <div class="pipeline-list">
          <ul>
            <li><a href="javascript:void(0);" [ngClass]="{'bg-pending': atendimento.status === 0 || (atendimento.status && atendimento.status > 0)}">Contato Inicial</a></li>
            <li><a href="javascript:void(0);" [ngClass]="{'bg-info': atendimento.status === 7 || (atendimento.status && atendimento.status > 3)}">Agendado</a></li>
            <li><a href="javascript:void(0);" [ngClass]="{'bg-warning': atendimento.status === 4 || (atendimento.status && atendimento.status > 4 && atendimento.status < 7)}">Aprovação</a></li>
            <li><a href="javascript:void(0);" [ngClass]="{'bg-pink': atendimento.status === 5 || (atendimento.status && atendimento.status > 5  && atendimento.status < 7)}">Assinatura</a></li>
            <li><a href="javascript:void(0);" [ngClass]="{'bg-success': atendimento.status === 6 || (atendimento.status && atendimento.status > 6  && atendimento.status < 7)}">Finalizado</a></li>
          </ul>
        </div>
        <div class="valor-potencial-texto">
          Valor em potencial - R$ {{ atendimento.valor | number:'1.2-2':'pt-BR' }}
        </div>
        <div class="row" style="margin-top: 40px;">
          <div class="col-md-8 col-lg-9" style="padding-right: 20px;">
            <div class="row">
              <div class="col-md-6">
                <div class="entretitulo">Tarefas</div>
              </div>
              <div class="col-md-6 text-right">
                <button class="btn btn-primary" (click)="abrirNovoCompromisso()">Nova tarefa</button>
              </div>
            </div>
            <table class="table table-striped" style="margin-top: 10px;">
              <thead>
              <tr>
                <th>Descrição</th>
                <th>Status</th>
                <th>Data Inicial</th>
                <th>Data Finalização</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let tarefa of atendimento.tarefas" (click)="buscarDetalheTarefa(tarefa.id)" style="cursor: pointer;">
                <td>#{{ tarefa.id }} - {{ tarefa.descricao }}</td>
                <td>
                  <div class="badge"
                       [ngClass]="{
                   'bg-afazer': tarefa.status === 1,
                   'bg-andamento': tarefa.status === 2,
                   'bg-validacao': tarefa.status === 3,
                   'bg-fechado': tarefa.status === 4
                 }">
                    {{ tarefa.status === 1 ? 'A fazer' :
                    tarefa.status === 2 ? 'Em andamento' :
                      tarefa.status === 3 ? 'Validação' :
                        'Fechado' }}
                  </div>
                </td>
                <td>
                  {{ tarefa.dataInicial | date:'dd/MM/yyyy' }}
                  <span class="time">{{ tarefa.dataInicial | date:'HH:mm:ss' }}</span>
                </td>
                <td>
                  {{ tarefa.dataFinalizacao | date:'dd/MM/yyyy' }}
                  <span class="time">{{ tarefa.dataFinalizacao | date:'HH:mm:ss' }}</span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-4 col-lg-3">
            <div class="entretitulo">Movimentações</div>
            <div class="col-md-12 texto-info-movimentacao" *ngFor="let log of atendimento?.historico">
              {{ log.texto }}<br>
              Data: {{ log.dataCadastro | date:'dd/MM/yyyy HH:mm:ss' }}<br>
              Usuario: {{ log.usuario }}
            </div>
          </div>
        </div>
        <app-detalhes-tarefas
          [showModal] = "showModalDetalhes"
          (fecharModalPai)="fecharModalDetalhes()"
        ></app-detalhes-tarefas>
        <app-novo-compromisso
          [showModal] = "showModalNovoCompromisso"
          (fecharModalPai) = "fecharNovoCompromisso()"
          (atualizarListaPai) = "fecharNovoCompromisso()"
        ></app-novo-compromisso>
      </div>
    </div>
  </section>
</div>
